import React from "react"

import styles from "./Heading.module.css"

const Heading = props => {
  const level = props.level ? props.level : 1

  const headingClass = props.className ? props.className : styles[`h${level}`]

  switch (level) {
    case 2:
      return <h2 className={headingClass}>{props.children}</h2>
    case 3:
      return <h3 className={headingClass}>{props.children}</h3>
    case 4:
      return <h4 className={headingClass}>{props.children}</h4>
    case 5:
      return <h5 className={headingClass}>{props.children}</h5>
    case 6:
      return <h6 className={headingClass}>{props.children}</h6>
    default:
      return <h1 className={headingClass}>{props.children}</h1>
  }
}

export default Heading
